import { useCallback, useEffect, useRef, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from 'config/firebase';
import { useFirebaseAuth } from 'context/FirebaseAuthContext';
import { normalizeStores } from '../lib/storeHelpers';
import { useRefreshOnVisible, useRequestGuard } from './useRequestGuard';

export function useShipStationStores() {
  const [user, authLoading] = useFirebaseAuth();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const guard = useRequestGuard();
  const hasFetched = useRef(false);
  const refresh = useCallback(async () => {
    const token = guard.begin();
    if (authLoading || !user) {
      hasFetched.current = false;
      setStores([]);
      setLoading(authLoading);
      return;
    }
    if (!hasFetched.current) setLoading(true);
    try {
      const snap = await getDocs(collection(db, 'shipStationStores'));
      if (!guard.current(token)) return;
      setStores(normalizeStores(snap.docs.map(d => d.data())));
      setError(null);
    } catch (err) {
      if (guard.current(token)) setError(err);
    } finally {
      if (guard.current(token)) {
        hasFetched.current = true;
        setLoading(false);
      }
    }
  }, [authLoading, user, guard]);
  useEffect(() => {
    refresh();
    return guard.invalidate;
  }, [refresh, guard]);
  useRefreshOnVisible(refresh);
  return { stores, loading, error, refresh };
}
